const config = {
	environment 	: 'PRD',
	// apiUrl			: 'https://dev.stockscreener.com.br:8082'
	apiUrl			: 'https://www.stockscreener.com.br:8082'
}

export default config